function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSezione05Popup04Ico02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 109.93 101.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M31.29,78.64c0,4.76-3.86,8.61-8.61,8.61s-8.61-3.86-8.61-8.61,3.85-8.61,8.61-8.61,8.61,3.86,8.61,8.61Z",
    style: {
      fill: "none",
      stroke: "#e7b835",
      strokeLinejoin: "round",
      strokeWidth: "2.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.76,100.17c0-7.13,5.78-12.92,12.92-12.92s12.92,5.78,12.92,12.92",
    style: {
      fill: "none",
      stroke: "#e7b835",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.88,78.64c0,4.76-3.86,8.61-8.61,8.61s-8.61-3.86-8.61-8.61,3.85-8.61,8.61-8.61,8.61,3.86,8.61,8.61Z",
    style: {
      fill: "none",
      stroke: "#e7b835",
      strokeLinejoin: "round",
      strokeWidth: "2.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.35,100.17c0-7.13,5.78-12.92,12.92-12.92s12.92,5.78,12.92,12.92",
    style: {
      fill: "none",
      stroke: "#e7b835",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.48,78.64c0,4.76-3.86,8.61-8.61,8.61s-8.61-3.86-8.61-8.61,3.85-8.61,8.61-8.61,8.61,3.86,8.61,8.61Z",
    style: {
      fill: "none",
      stroke: "#e7b835",
      strokeLinejoin: "round",
      strokeWidth: "2.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.59,61.42h62.43c3.57,0,6.46-2.89,6.46-6.46V7.61c0-3.57-2.89-6.46-6.46-6.46H18.37M82.95,100.17c0-7.13,5.78-12.92,12.92-12.92s12.92,5.78,12.92,12.92",
    style: {
      fill: "none",
      stroke: "#e7b835",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.61,20.52c0,4.76,3.86,8.61,8.61,8.61s8.61-3.85,8.61-8.61-3.86-8.61-8.61-8.61-8.61,3.85-8.61,8.61Z",
    style: {
      fill: "none",
      stroke: "#e7b835",
      strokeLinejoin: "round",
      strokeWidth: "2.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2,18.37h21.53M44.2,9.76h21.53M65.73,39.9v12.92M91.56,18.37v34.44M74.34,24.83v27.98M82.95,33.44v19.37M1.15,61.42v-17.22c0-8.03,4.37-12.92,15.07-12.92h32.29c2.38,0,4.3,1.93,4.3,4.31s-1.93,4.3-4.3,4.3h-17.22c-2.38,0-4.31,1.93-4.31,4.31v17.22",
    style: {
      fill: "none",
      stroke: "#e7b835",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.3px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSezione05Popup04Ico02);
export default __webpack_public_path__ + "static/media/sezione-05-popup-04-ico-02.093b6ddfba9ddb4ceb5bb21091923d9c.svg";
export { ForwardRef as ReactComponent };